import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

function ItemsToCheck({itemText, itemValue}) {
  return (
    <div className="uebersicht__itemsToCheck">
      {itemValue !== undefined && (
        <div className="uebersicht__itemsToCheck-counter" data-testid="uebersicht__itemsToCheck-counter">
          {`${itemValue} `}
        </div>
      )}
      <div className="uebersicht__itemsToCheck-type">{`${itemText} ${i18n.t('uebersicht_itemsToCheck')}`}</div>
    </div>
  )
}

ItemsToCheck.propTypes = {
  itemText: PropTypes.string.isRequired,
  itemValue: PropTypes.number,
}

export default ItemsToCheck
